import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";

declare global {
  interface Window {
    clarity?: (action: string, ...args: any[]) => void;
  }
}

export const useClarityTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && window.clarity) {
      const searchString = new URLSearchParams(location.search).toString();
      const fullPath = location.pathname + (searchString ? `?${searchString}` : "");

      window.clarity("set", "current_url", fullPath);
      window.clarity("event", "virtual_page_view");
    }
  }, [location.pathname, location.search]);
};
